import { DOCUMENT, inject, Injectable } from '@angular/core';
import { TokenService } from '@services/token/token.service';
import { QUERY_PARAMS } from '@constants/query-params';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private tokenService = inject(TokenService);
  private location = inject(DOCUMENT).location;

  async toLoginPage(companyName: string, navigateToProjectRoot = false) {
    this.logOut();

    const returnUrl = navigateToProjectRoot ? this.location.origin : this.location.href;

    const url = new URL(environment.loginUrl(companyName));
    url.searchParams.set(QUERY_PARAMS.RETURN_URL, returnUrl);

    this.location.replace(url.toString());
  }

  logOut(): void {
    this.tokenService.removeToken();
  }
}
